export enum ClassNames {
  PreventScroll = 'prevent-scroll',
}
